import { TRANSLATIONS, type TranslationCode } from "@versedrill/core";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useVersions } from "@/lib/useVersions.ts";
import { cn } from "@/lib/utils";

/**
 * Pick the Bible version to read in. With only one version available it is just a label, so nothing changes for a
 * deployment that hasn't loaded the others.
 */
export function VersionSelect({ compact = false, id, className }: { compact?: boolean; id?: string; className?: string }) {
  const { available, current, choose } = useVersions();
  const label = TRANSLATIONS[current].label;

  if (available.length < 2) {
    return <span className={cn("font-ui uppercase tracking-widest text-muted-foreground/80", compact ? "align-middle text-[0.62rem]" : "text-sm", className)}>{label}</span>;
  }
  return (
    <Select value={current} onValueChange={(v) => choose(v as TranslationCode)}>
      <SelectTrigger
        id={id}
        size="sm"
        aria-label="Bible version"
        className={cn(
          compact
            ? "inline-flex h-6 gap-1 rounded-sm px-1.5 py-0 align-middle font-ui text-[0.62rem] uppercase tracking-widest text-muted-foreground shadow-none"
            : "h-9 w-auto min-w-36 font-ui",
          className,
        )}
      >
        <SelectValue>{label}</SelectValue>
      </SelectTrigger>
      <SelectContent align="start">
        {available.map((code) => (
          <SelectItem key={code} value={code}>
            <span className="font-semibold">{TRANSLATIONS[code].label}</span>
            <span className="ml-2 text-muted-foreground">{TRANSLATIONS[code].name}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
